__turbopack_context__.v({
  "canvas_wrapper": "CanvasEmbed-module__keQg_W__canvas_wrapper",
  "canvas_wrapper_expanded": "CanvasEmbed-module__keQg_W__canvas_wrapper_expanded",
  "iframe": "CanvasEmbed-module__keQg_W__iframe",
  "open_canvas_button": "CanvasEmbed-module__keQg_W__open_canvas_button",
  "spinnerOverlay": "CanvasEmbed-module__keQg_W__spinnerOverlay",
});
